export enum ListViewOptions {
  Table = 'table',
  Grid = 'grid',
}
